module.exports = __webpack_public_path__ + "static/media/wood.c556c198.png";